import { useMemo } from 'react';

import { getFilterOptions } from '../../../helpers/filter';

export const useFilterOptions = data => {
  return useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) {
      return {
        priority: [],
        status: [],
        type: []
      };
    }

    return {
      priority: getFilterOptions(data, 'priority'),
      status: getFilterOptions(data, 'status'),
      type: getFilterOptions(data, 'type')
    };
  }, [data]);
};
